import { connect } from 'react-redux'

import * as OrgSelectors from 'modules/org/selectors'
import * as UserSelectors from 'modules/user/selectors'
import * as ProfileSelectors from 'modules/profile/selectors'

import ProfilePreview from './component'

const mapStateToProps = state => ({
  color: OrgSelectors.getColor(state),
  name: UserSelectors.getName(state),
  jobTitle: ProfileSelectors.getJobTitle(state),
  companyName: ProfileSelectors.getCompanyName(state),
  coverPhotoUrl: ProfileSelectors.getCoverPhotoUrl(state),
  stagedProfilePicture: UserSelectors.getProfilePicture(state),
})

export default connect(mapStateToProps)(ProfilePreview)



// WEBPACK FOOTER //
// ./src/layouts/ProfilePreview/index.js